import { Component, ElementRef, HostListener, inject, input, OnInit } from '@angular/core';
import { LpActionsService } from '@features/lp/lp-actions/lp-actions.service';
import { ILpCanvasElementContext } from '@features/lp/lp-canvas/lp-canvas.types';
import { LpOnClickCanvasComponent } from '@typings/lp/generated';

@Component({
  selector: 'lp-on-click-canvas-component',
  imports: [],
  templateUrl: './lp-on-click-canvas-component.component.html',
  styleUrl: './lp-on-click-canvas-component.component.css',
})
export class LpOnClickCanvasComponentComponent implements OnInit {
  public static readonly DRAG_THRESHOLD = 25; // px
  readonly #lpActionsService = inject(LpActionsService);
  readonly el = inject<ElementRef<HTMLElement>>(ElementRef);

  comp = input.required<LpOnClickCanvasComponent>();
  context = input.required<ILpCanvasElementContext>();

  downPosition = { x: 0, y: 0 };

  ngOnInit(): void {
    this.context()
      .requirePointerEvents('pointer')
      .transition('filter 0.25s ease')
      .transition('scale 0.25s var(--ease-in-out-back)')
      .setHoverStyle({
        filter: 'brightness(1.2)',
      })
      .setActiveStyle({
        scale: '1',
      });
  }

  @HostListener('document:pointerdown', ['$event'])
  protected onKeydown(event: PointerEvent) {
    this.downPosition = event;
  }

  @HostListener('document:click', ['$event'])
  async onClick(event: MouseEvent) {
    const moveVec = {
      x: event.x - this.downPosition.x,
      y: event.y - this.downPosition.y,
    };
    const distance = moveVec.x ** 2 + moveVec.y ** 2;
    if (distance > LpOnClickCanvasComponentComponent.DRAG_THRESHOLD ** 2) {
      // Ignore click if it was a drag
      return;
    }

    const isClicked = this.context().el.nativeElement.contains(event.target as Node);
    if (!isClicked) return;

    await this.#lpActionsService.perform(this.comp().onClick);
  }
}
